import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setHeaderTitle } from "../../../../redux/headerTitle/headerTitleSlice";
import { changeRouteType, getpervInnerState } from "../../../../redux/handleBackBtn/handleBackBtnSlice";
import { IInnerStateHomeMenu } from "../IHomeMenu";
import FourPartsCard from "../../../../components/card/fourPartsCard/fourPartsCard";
import { useMutation, useQueryClient } from "react-query";
import { GetCustomerSales } from "../../../../services/sale.service";
import { IGetCustomerSaleResponse } from "../../../../models/sale.model";
import { SALE_ID } from "../../../../config/cacheKey";
import EmptyStyle from "../../../../components/emptyStyles/emptyStyle";
import CustomisedButton from "../../../../components/button/button";
import { getpervStateTab } from "../../../../redux/loansTab/loansTabSlice";
import LoansSkeleton from "../../loansTab/Loans/loansSkeleton";
import EmptyLoanStyle from "../../../../components/icons/EmptyLoanStyle";
import { useNavigate } from "react-router-dom";


export default function PurchaseRecords({ setState, setTabChild }: IInnerStateHomeMenu) {
    const navigate = useNavigate();
    const [data, setData] = useState<IGetCustomerSaleResponse[]>();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation(GetCustomerSales, {
        onSuccess: (data) => {
            setData(data)
        }
    });
    const handleDetail = (saleId: number) => {
        setState!('purchaseRecordDetail');
        queryClient.setQueryData(SALE_ID, saleId);
    }
    useEffect(() => {
        mutateAsync();
        queryClient.removeQueries(SALE_ID);
    }, [])
    const dispatch = useDispatch();
    const randomKeyForDispatch = Math.random();
    const handleStore = () => {
        navigate('/market')
    }
    useEffect(() => {
        dispatch(setHeaderTitle({ color: 'var(--header-color)', header: 'سوابق خرید', parentRoute: 'home' }));
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: `home ${randomKeyForDispatch}` }));
    }, []);
    if (isLoading) {
        return <LoansSkeleton />;
    }
    return (
        // <div className='p-5' style={{ height: 'calc(100svh - 60px)', overflowY: 'scroll' }}>
        <div style={{ height: "100%" }} className="content-container p-5 mt-5 !h-[calc(100svh-120px)]">
            <div style={{ overflowY: "auto" }}>
                {data && data.length > 0 ? <>{data?.map((item, index) => (<FourPartsCard amount={item.totalAmount} date={item.salesDatePersian} logo={item.storeLogoBase64} companyName={item.storeTitle}
                    onClick={() => handleDetail(item.saleId)}
                    key={index} />))}</> :
                    <>
                        <div className="w-full h-full flex flex-col justify-center items-center gap-20 p-20">
                            <EmptyStyle icon={<EmptyLoanStyle className="className='text-[var(--primary-text-color)]'" />} text={'تاکنون خریدی ثبت نشده است.'} emphasisedWords={['خریدی ثبت نشده ']} emphasisedWordsColor={'#BBA57A'} />

                        </div>
                    </>
                }
            </div>
            {/* <div className="w-full py-5 sm:pt-4">

                <CustomisedButton title="مشاهده فروشگاه‌ها" disable={false} onClick={handleStore} type="button" />
            </div> */}
        </div >
    )
}
